import { useEffect, useState } from "react";
import { Layers, CalendarDays } from "lucide-react";
import { Layout } from "../components/layout/Layout";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { EmptyState } from "../components/common";
import { FicheModules } from "../components/FicheModules";
import { FicheSessions } from "../components/FicheSessions";
import { FicheHeader, FicheIdentity, ProgressSummary } from "./eleves/EleveDetailPage";
import { api, formatApiError } from "../lib/api";

// Espace élève : sa propre fiche, en lecture seule.
export default function MonSuiviPage() {
  const [fiche, setFiche] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get("/me/fiche").then(({ data }) => setFiche(data)).catch((e) => setError(formatApiError(e.response?.data?.detail))); }, []);
  if (error) return <Layout title="Mon suivi"><p className="text-muted-foreground">{error}</p></Layout>;
  if (!fiche) return <Layout title="Mon suivi"><p className="text-muted-foreground">Chargement...</p></Layout>;
  return (
    <Layout title="Mon suivi">
      <div className="grid gap-5 lg:grid-cols-[320px_1fr]">
        <aside>
          <section className="rounded-xl border border-border bg-card p-5 space-y-5">
            <FicheHeader fiche={fiche} />
            <ProgressSummary fiche={fiche} />
            <FicheIdentity fiche={fiche} />
          </section>
        </aside>
        <div className="min-w-0">
          <Tabs defaultValue="modules">
            <TabsList>
              <TabsTrigger value="modules" className="gap-1.5"><Layers size={14} /> Mes modules ({fiche.modules.length})</TabsTrigger>
              <TabsTrigger value="planning" className="gap-1.5"><CalendarDays size={14} /> Mes cours ({fiche.sessions?.length || 0})</TabsTrigger>
            </TabsList>
            <TabsContent value="modules" className="mt-4">
              {fiche.modules.length ? <FicheModules eleveId={fiche.id} modules={fiche.modules} readOnly onModule={() => {}} /> :
                <div className="rounded-xl border border-border bg-card"><EmptyState icon={Layers} title="Aucun module pour l'instant" text="Vos modules apparaîtront ici dès que votre formateur les aura ajoutés." /></div>}
            </TabsContent>
            <TabsContent value="planning" className="mt-4"><FicheSessions sessions={fiche.sessions} /></TabsContent>
          </Tabs>
        </div>
      </div>
    </Layout>
  );
}
